/******************************************************************************
 * Memokid: A game to train one's memory                                      *
 * Copyright (C) 2022 Lukas Laag                                              *
 * This file is part of Memokid                                               *
 *                                                                            *
 * Memokid is free software: you can redistribute it and/or modify            *
 * it under the terms of the GNU General Public License as published by       *
 * the Free Software Foundation, either version 3 of the License, or          *
 * (at your option) any later version.                                        *
 *                                                                            *
 * Memokid is distributed in the hope that it will be useful,                 *
 * but WITHOUT ANY WARRANTY; without even the implied warranty of             *
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the              *
 * GNU General Public License for more details.                               *
 *                                                                            *
 * You should have received a copy of the GNU General Public License          *
 * along with Memokid.  If not, see <https://www.gnu.org/licenses/>.          *
 *                                                                            *
 ******************************************************************************/

import { useCallback } from 'react'
import { connect } from 'react-redux'
import { useIntl } from 'react-intl'
import FormControl from '@mui/material/FormControl'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import { ensureLoaded, settingsChangeDeck } from '../../actions/game'
import { CardSet } from '../CardSet'
import { LEVELS, log } from '../../logs'
import './DeckPicker.css'

const DeckPicker = props => {
  log('DeckPicker', LEVELS.INFO, props)
  const { decks, settings: { deckRefid, cardCount }, dispatch } = props
  const intl = useIntl()
  const deck = ensureLoaded(decks[deckRefid], dispatch)
  const cards = deck.cards
  const cardRefids = cards.map((card) => card.id)

  const handleChange = useCallback(event => {
    log('DeckPicker', LEVELS.DEBUG, 'handleChange', event)
    const deckRefid = event.target.value
    dispatch(settingsChangeDeck(deckRefid, decks[deckRefid].cards.length))
  }, [])
  return (
    <div className='settings-deck-picker'>
      <FormControl fullWidth>
        <Select
          value={deckRefid}
          onChange={handleChange}
        >
          {decks.map((deck, index) =>
            <MenuItem key={deck.id} value={deck.id}>{intl.formatMessage({ id: deck.nlsid })}</MenuItem>)}
        </Select>
      </FormControl>
      <CardSet
        cards={cards}
        cardRefids={cardRefids}
        width='64px'
        height='64px'
        max={cardCount}
      />
    </div>
  )
}

DeckPicker.displayName = 'DeckPicker'

const mapStateToProps = ({ decks, settings }) => ({ decks, settings })
export default connect(mapStateToProps)(DeckPicker)
